import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import avatar from './modules/avatar'
import project from './modules/project'
import user from './modules/user'

Vue.use(Vuex)

export const store = new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    avatar,
    project,
    user
  },
  state: {
    // user: null,
    // userPhoto: null,
    // projectsData: null,
    // selectedProjectData: null,
    alerts: {},
    toasts: {}
  },
  mutations: {
    // setUser (state, payload) {
    //   state.user = payload
    // },
    // setUserPhoto (state, payload) {
    //   state.userPhoto = payload
    // },
    // setUserName (state, payload) {
    //   state.user.name = payload
    // },
    // setProjectsData (state, payload) {
    //   state.projectsData = payload
    // },
    // setSelectedProjectData (state, payload) {
    //   state.selectedProjectData = payload
    // },
    setAlert (state, payload) {
      Vue.set(state.alerts, payload, true)
    //  state.alerts[payload] = true
    },
    removeAlert (state, payload) {
      if (state.alerts[payload]) {
        delete state.alerts[payload]
      }
    },
    clearAlerts (state) {
      state.alerts = {}
    },
    setToast (state, payload) {
      state.toasts[payload] = true
    },
    removeToast (state, payload) {
      if (state.toasts[payload]) {
        delete state.toasts[payload]
      }
    }
  },
  actions: {
    removeAlert ({commit}, payload, dispatch) {
      commit('removeAlert', payload)
    },
    clearAlerts ({commit}) {
      commit('clearAlerts')
    }
    // signUpUser ({commit}, payload, dispatch) {
    //   firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
    //     .catch(
    //       error => {
    //         console.error(error)
    //         commit('setAlert', error.code)
    //       }
    //     )
    // },
    // updateAuthData ({commit, dispatch}, payload) {
    //   let newUser = null
    //   if (payload !== null) {
    //     newUser = {
    //       name: payload.displayName,
    //       email: payload.email,
    //       emailVerified: payload.emailVerified,
    //       id: payload.uid
    //     }
    //   }
    //   commit('setUser', newUser)
    // },
    // logInUser ({commit, dispatch}, payload) {
    //   firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
    //   .catch(
    //     error => {
    //       console.error(error)
    //       commit('setAlert', error.code)
    //     }
    //   )
    // },
    // setDisplayName ({commit}, payload) {
    //   var user = firebase.auth().currentUser
    //   user.updateProfile({
    //     displayName: payload.userName
    //   }).then(function () {
    //     commit('setUserName', payload.userName)
    //   }).catch(function (error) {
    //     console.log(error)
    //   })
    // },
    // logOutUser ({commit}) {
    //   firebase.auth().signOut()
    //   .catch(function (error) {
    //     console.log(error)
    //   })
    // },
    // googleSignUp () {
    //   var provider = new firebase.auth.GoogleAuthProvider()
    //   firebase.auth().signInWithRedirect(provider)
    // },
    // fetchProjects ({commit, state}) {
    //   var ref = firebase.database().ref('users')
    //   ref.orderByChild('uid').equalTo(state.user.id).on('child_added', function (snapshot) {
    //     commit('project/setProjectsData', snapshot.val().projects)
    //   })
    // },
    // setProjectData ({commit, state}, payload) {
    //   firebase.database().ref('projects/' + payload.projectID + '/properties').once('value').then(function (snapshot) {
    //     commit('project/setSelectedProject', snapshot.val())
    //   })
    // },
    // sendVerificationEmail () {
    //   var user = firebase.auth().currentUser
    //   // var actionCodeSettings = {
    //   //   url: 'https://tellus.com/userinfo'
    //   // }
    //  // user.sendEmailVerification(actionCodeSettings).then(function () {
    //   user.sendEmailVerification().then(function () {

    //   }).catch(function (error) {
    //     console.log(error)
    //   })
    // }
  },
  getters: {
    // currentUser (state) {
    //   if (state.user !== null) {
    //     return state.user.id
    //   } else {
    //     return null
    //   }
    // },
    // displayName (state) {
    //   if (state.user !== null) {
    //     return state.user.name
    //   } else {
    //     return null
    //   }
    // },
    // user (state) {
    //   return state.user
    // },
    // isLoggedIn (state) {
    //   return state.user != null
    // },
    // projects (state) {
    //   return state.projectsData
    // },
    // selectedProjectData (state) {
    //   return state.selectedProjectData
    // },
    alerts (state) {
      return state.alerts
    },
    alertCount  (state) {
      return Object.keys(state.alerts).length
    },
    toasts (state) {
      return state.toasts
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js